import React from "react";

export default function OpinieSection() {
  const opinie = [
    {
      autor: "Weronika Wójcik",
      tekst:
        "Jesteśmy bardzo zadowoleni z pracy Filipa na naszym weselu! Świetnie dobierał repertuar, zachęcał gości na parkiet dzięki czemu wszyscy świetnie się bawili, był charyzmatyczny, nie zabrakło też klubowych kawałków więc każdy znalazł coś dla siebie. Komunikacja na najwyższym poziomie, Filip spełniał każde nasze życzenie. Serdecznie polecamy!",
    },
    {
      autor: "Oktawia Pelczar",
      tekst:
        "Filip (DJ Kusy) to absolutny mistrz tworzenia klimatu! Od pierwszej chwili wprowadził wyjątkową atmosferę i porwał do zabawy wszystkich – od najmłodszych po najstarszych. Ma niesamowity takt i wyczucie gustu, dzięki czemu każdy moment był dopracowany w najmniejszym szczególe. Do tego jest mega ekstrawertykiem z energią i vibe’em kogoś, kogo zna się od zawsze. Po prostu klasa sama w sobie!",
    },
    {
      autor: "Kamil Winiarski",
      tekst:
        "Z całego serca polecamy DJ'a który poprowadził nasze przyjęcie weselne w sposób profesjonalny uwzględniając w całości nasze preferencje muzyczne i dostosowując muzykę pod upodobania gości. Dzięki DJ Kusemu goście bawili się do białego rana. My jako para młoda czuliśmy, że Filip w 100% zapewni dobrą zabawę i o nic nie musieliśmy się martwić. Dziękujemy za wszystko 🧡",
    },
    {
      autor: "Wiktoria Pelczarska",
      tekst:
        "Bardzo polecam!! Filip super prowadził całą imprezę, dał z siebie wszystko żeby każdy dobrze się bawił, super muzyka i pełen profesjonalizm. Nie wyobrażam sobie wybrać innego DJ’a ❤️",
    },
  ];

  return (
    <section
      id="opinie"
      className="pt-10 sm:pt-12 pb-20 sm:pb-36 bg-white text-black"
    >
      <h2
        className="text-3xl xs:text-4xl md:text-6xl font-extrabold mb-4 text-center uppercase tracking-wide"
        style={{
          textShadow: "0 3px 16px #000, 0 1px 4px #00000080, 0 1px 0 #fff",
          letterSpacing: "0.04em",
        }}
      >
        Opinie Google
      </h2>

      <p className="text-center text-gray-500 mb-10">
       
      </p>

      <div className="overflow-x-auto">
        <div className="flex gap-4 sm:gap-6 px-2 xs:px-4 md:px-12 w-fit mx-auto flex-nowrap">
          {opinie.map((opinia, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 shadow-md rounded-2xl p-5 xs:p-6 sm:p-8 text-center w-[260px] xs:w-[300px] sm:w-[340px] min-h-[220px] sm:min-h-[260px] flex flex-col justify-between hover:shadow-xl hover:-translate-y-1 transition duration-300"
            >
              <div className="text-yellow-400 mb-3">★★★★★</div>

              <p className="text-zinc-800 text-base mb-4 leading-relaxed italic mx-auto max-w-[95%]">
                “{opinia.tekst}”
              </p>

              <p className="text-sm font-bold text-gray-500 mt-4">
                – {opinia.autor}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
